module.exports = __webpack_public_path__ + "img/tixel-white.ce216940.svg";